import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import IndeterminateCheckBoxIcon from "@material-ui/icons/IndeterminateCheckBox";
import AddBoxIcon from "@material-ui/icons/AddBox";
import EditIcon from '@material-ui/icons/Edit';
import {
  alertsConfirmAction,
  auditMembersOpenAction,
} from "../features/sliceReducer/interactionReducer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../features/store";
import { deleteAuditMembersAction } from "../features/sliceReducer/projectReducer";
import { initializeAuditMember } from "../models/IPAuditMember";
import IPUtility from "../classes/IPUtility";

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    caption: {
      padding: "24px 0 0 24px",
      fontWeight: "bold",
      fontSize: "18px",
    },
    tableContainer: {
      position: "relative",
      display: " flex",
      padding: "0px 24px 40px",
    },
    table: {
      "& .MuiTableCell-root": {
        padding: "12px",
        // borderBottom: "1px solid grey",
      },
    },

    addButton: {
      position: "absolute",
      padding: "16px",
      top: 0,
      right: 0,
    },
  })
);

interface AuditMembersProps {
  editHandler: any;
}

const AuditMembers = (props: AuditMembersProps) => {
  const classes = useStyle();
  const dispatch = useDispatch();

  const { currentProject } = useSelector((state: RootState) => state.project);

  return (
    <React.Fragment>
      <Box>
        <Typography variant="subtitle1">
          <PersonAddIcon
            style={{ marginRight: "8px", verticalAlign: "middle" }}
          />
          감사팀의 구성
        </Typography>
        <Box className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell width="15%">구분</TableCell>
                <TableCell width="15%">성명</TableCell>
                <TableCell width="15%">소속/지위</TableCell>
                <TableCell width="15%">감사상직책/경력</TableCell>
                <TableCell width="25%">주요 감사 내용</TableCell>
                <TableCell width="15%" align="right">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddBoxIcon />}
                    onClick={() => {
                      props.editHandler({ ...initializeAuditMember, uuid: IPUtility.generateUUID() });
                      dispatch(auditMembersOpenAction())
                        ;
                    }}
                  >
                    추가
                  </Button>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentProject?.auditMembers?.map((member, index) => (
                <TableRow key={index + "-" + member.uid}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{member.name}</TableCell>
                  <TableCell>{member.department}</TableCell>
                  <TableCell>{member.position}</TableCell>
                  <TableCell>{member.duty}</TableCell>
                  <TableCell align="right">
                    <Box>
                      <Button
                        onClick={() => {
                          dispatch(
                            alertsConfirmAction({
                              alertContent: "해당 스케줄을 삭제하시겠습니까?",
                              alertAction: deleteAuditMembersAction(member.uuid),
                            })
                          );
                        }}
                      >
                        <IndeterminateCheckBoxIcon
                          style={{
                            color: "#f44336",
                            fontSize: "26px",
                          }}
                        />
                      </Button>
                    </Box>
                    <Button onClick={() => {
                      dispatch(auditMembersOpenAction());
                      props.editHandler(member);
                    }}>
                      <EditIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default AuditMembers;
